import { jsx as _jsx } from "react/jsx-runtime";
import { TabStyles } from "@/components/UI/Tabs/TabStyles";
import { Box, useFocusable, useHoverable, usePressable } from "@gemini/core";
import { useRef } from "react";
import { VariantEnum } from "./types";
export const NavigationBarTab = ({ label, name, isActive, onPress, firstTabMargin, lastTabMargin, variant, }) => {
    const ref = useRef(null);
    const { boxProps: hoverProps, isHovered } = useHoverable();
    const { boxProps: focusProps, isFocused } = useFocusable(ref);
    const { boxProps: pressProps, isPressed } = usePressable({ onPress });
    const getBackgroundStyles = () => {
        if (variant === VariantEnum.TAGS) {
            return Object.assign({ marginLeft: firstTabMargin !== null && firstTabMargin !== void 0 ? firstTabMargin : null, marginRight: lastTabMargin !== null && lastTabMargin !== void 0 ? lastTabMargin : null, paddingHorizontal: "spacing.12", paddingVertical: "spacing.6", height: "spacing.32" }, TabStyles({
                isHovered,
                isPressed,
                isFocused,
                isActive,
                tabMode: "light",
            }));
        }
        else {
            return Object.assign({ color: "color.content.active.default", paddingVertical: "spacing.12", paddingHorizontal: "spacing.24", 
                // @ts-ignore
                typography: "typography.body.14.regular", height: "spacing.48" }, (isActive
                ? {
                    typography: "typography.body.16.bold", // missing gemini token
                    borderBottomWidth: "borderWidth.2",
                    borderBottomColor: "color.border.active.default",
                }
                : {
                    borderBottomWidth: "borderWidth.1",
                    borderBottomColor: "unsafe_component.topBar.color.border",
                }));
        }
    };
    return (
    // @ts-ignore
    _jsx(Box, Object.assign({ as: "button", id: `tab-${name}`, ref: ref, role: "tab", display: "flex", alignItems: "center", flexWrap: "nowrap", cursor: "pointer", borderWidth: "borderWidth.none", borderBottomStyle: "solid", onClick: onPress, "aria-selected": isActive }, pressProps, hoverProps, focusProps, getBackgroundStyles(), { children: _jsx(Box, { as: "span", whiteSpace: "nowrap", children: label }) })));
};
